import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { Grid } from '@mui/material';
import PartnerRelationsListItemComponent from './PartnerRelationsListItemComponent';
import { DetatchedAccordion } from 'components/common/CommonStyles';
import { Typography } from '@totalsoft/rocket-ui';

const PartnerRelationsListComponent = ({
  dispatch,
  t,
  documentPartnerRelations,
  partnerRelationTypes,
  onPropertyChange,
  onSave,
  validation
}) => {
  const onExpandChange = index => {
    dispatch({ type: 'OnExpandChange', index: index });
  };

  return documentPartnerRelations.map((item, idx) => {
    return (
      <Grid container key={`${item.partnerRelationId}-${idx}`}>
        <DetatchedAccordion
          expanded={item.isExpanded}
          onChange={() => onExpandChange(idx)}
          title={
            <Typography>
              {item.directPartnerId || item.reversePartnerId || item.relationTypeId
                ? `${item.directPartnerName} - ${item.directRelation} - ${item.reversePartnerName}`
                : t('Offer.PartnerRelations.NewRelation')}
            </Typography>
          }
          content={
            <PartnerRelationsListItemComponent
              item={item}
              partnerRelationTypes={partnerRelationTypes}
              index={idx}
              onPropertyChange={onPropertyChange}
              validation={validation[idx]}
              onSave={onSave}
            />
          }
        />
      </Grid>
    );
  });
};

PartnerRelationsListComponent.propTypes = {
  documentPartnerRelations: PropTypes.array.isRequired,
  partnerRelationTypes: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired
};

export default compose(withTranslation())(PartnerRelationsListComponent);
